module.exports = __webpack_public_path__ + "static/media/allGoods.935e5f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/allGoods.png
// module id = 423
// module chunks = 0